import React, { Suspense } from 'react';
import { Text } from 'react-native';
const Lottie = /*#__PURE__*/React.lazy(() => import('lottie-react'));
const LottieLoaderSkeleton = _ref => {
  let {
    animationData,
    lottieStyle
  } = _ref;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Text, null, "Loading...")
  }, /*#__PURE__*/React.createElement("style", null, `.lottieLoadingTextContainer svg,
        .lottieLoadingText svg path {
          fill: ${undefined};
          color: ${undefined};
          stroke: ${undefined};
        }`), /*#__PURE__*/React.createElement("div", {
    className: "lottieLoadingTextContainer"
  }, /*#__PURE__*/React.createElement(Lottie, {
    key: 'loadingSkeleton-' + Math.random(),
    style: lottieStyle,
    autoPlay: true,
    loop: true,
    animationData: animationData
  })));
};
export default LottieLoaderSkeleton;
//# sourceMappingURL=index.web.js.map